import * as moment from 'moment-timezone';

export namespace DateHelpers {
  export function fromISOString(dateString: string): Date | undefined {
    if (!dateString || !moment(dateString, 'YYYY-MM-DDTHH:mm:ss.sssZ').isValid()) {
      return undefined;
    }
    return moment(dateString).toDate();
  }

  export function toISOString(date: Date): string {
    if (invalidDate(date)) {
      return '';
    }
    return moment(date).toISOString();
  }
}

function invalidDate(date: Date): boolean {
  return !moment(date).isValid();
}
